require('dotenv').config()

/// /////////////////////////
//    KNACK
/// /////////////////////////

export const KNACK_DB_VERSION =
  process.env.VUE_APP_KNACK_DB_VERSION || 'development'
export const KNACK_API_KEY = process.env.KNACK_API_KEY
export const KNACK_APPLICATION_ID = process.env.KNACK_APPLICATION_ID


/// /////////////////////////
//    SENTRY
/// /////////////////////////

export const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN
export const SENTRY_PROJECT_ID = process.env.VUE_APP_SENTRY_PROJECT_ID

/// /////////////////////////
//    TWILIO
/// /////////////////////////

export const TWILIO_ACCOUNT_ID = process.env.TWILIO_ACCOUNT_ID
export const TWILIO_FLOW_ID = process.env.TWILIO_FLOW_ID
export const TWILIO_AUTH_TOKEN = process.env.TWILIO_AUTH_TOKEN
export const TWILIO_NUMBER = process.env.TWILIO_NUMBER
export const TWILIO_MSG_SERVICE_ID = process.env.TWILIO_MSG_SERVICE_ID
